export const corsHeader = () => {
    return { 'Access-Control-Allow-Origin': '*' };
};
